export const ADMIN_HOME = "/admin"
export const ADMIN_BUSINESSES = "/admin/businesses"
export const ADMIN_BUSINESSES_CREATE = "/admin/businesses/create"
export const ADMIN_BUSINESSES_IMPORT = "/admin/businesses/import"
export const ADMIN_BUSINESSES_SHOW = "/admin/businesses/:id"
export const ADMIN_PENDING_APPROVALS = "/admin/pending-approvals"
export const ADMIN_SUPPORT = "/admin/support"
export const ADMIN_ADMINS = "/admin/admins"
export const ADMIN_ADMINS_INVITE = "/admin/admins/invite"
export const ADMIN_ADMINS_IMPORT = "/admin/admins/import"
export const ADMIN_MESSAGING = "/admin/messaging"
export const ADMIN_TRANSACTIONS = "/admin/transactions"
export const ADMIN_PAYOUTS = "/admin/payouts"
export const ADMIN_AD_PLANS = "/admin/ad-plans"
export const ADMIN_BUSINESS_PLANS = "/admin/business-plans"
export const ADMIN_INDUSTRIES = "/admin/industries"
export const ADMIN_SETTINGS = "/admin/settings"
export const ADMIN_SETTINGS_PROFILE = "/admin/settings/profile"

export const ADMIN_SERVICES = "/admin/services"
export const ADMIN_SERVICES_CREATE = "/admin/services/create"
export const ADMIN_SERVICES_SHOW = "/admin/services/:id"
export const ADMIN_SERVICES_EDIT = "/admin/services/:id/edit"

export const ADMIN_PROVIDERS = "/admin/providers"
export const ADMIN_PROVIDERS_CREATE = "/admin/providers/create"
export const ADMIN_PROVIDERS_SHOW = "/admin/providers/:id"
export const ADMIN_PROVIDERS_EDIT = "/admin/providers/:id/edit"

export const ADMIN_PENDING_AD_CAMPAIGNS = "/admin/pending-ad-campaigns"

export const ADMIN_AD_CAMPAIGNS = "/admin/ad-campaigns"
export const ADMIN_AD_CAMPAIGNS_CREATE = "/admin/ad-campaigns/create"
export const ADMIN_AD_CAMPAIGNS_SHOW = "/admin/ad-campaigns/:id"
export const ADMIN_AD_CAMPAIGNS_EDIT = "/admin/ad-campaigns/:id/edit"

export const ADMIN_APPOINTMENTS = "/admin/appointments"
export const ADMIN_APPOINTMENTS_SHOW = "/admin/appointments/:id"

export const ADMIN_CUSTOMERS = "/admin/customers"
export const ADMIN_CUSTOMERS_SHOW = "/admin/customers/:id"
